import React, { useState, useContext } from "react";
import {
  encryptString,
  // createSession,
  userLogout,
} from "../../services/apiUtils";
import Loader from "../../components/common/Loader";
import { ToastContainer, toast } from "react-toastify";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";

const OTPAuthentication = ({
  onClose,
  setShowModal,
  onVerificationSuccess,
  txnId,
  verifyWith,
  loginId,
}) => {
  const [OtpText, setOtpText] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(60);
  const [resendCount, setResendCount] = useState(1);
  const [otpError, setOtpError] = useState("");
  const [currentTxnId, setCurrentTxnId] = useState(txnId);

  const { setDataByKey } = useContext(GlobalContext);
  const { getDataByKey } = useContext(GlobalContext);

  // const xToken = localStorage.getItem("x_token");

  const navigate = useNavigate();
  const handleLogout = () => {
    userLogout(navigate);
  };

  // Countdown timer effect
  React.useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  /**
   * Function to handle resend OTP
   */
  const handleResendOtp = async () => {
    if (resendCount >= 3) {
      toast.error("Maximum resend attempts reached");
      return;
    }

    try {
      setIsPageLoading(true);
      // const sessionResponse = await createSession();
      //  const accessToken = sessionResponse?.accessToken;

      // if (!accessToken) {
      //   toast.error("Access token is missing.");
      //   setIsPageLoading(false);
      //   return;
      // }

      let url = "";
      const header = {
        headers: {
          "Content-Type": "application/json",
          // xtoken: `${xToken}`,
          // accesstoken: `${accessToken}`,
        },
      };

      if (verifyWith === "mobile") {
        url = `${API_BASE_URL}/abha/update/mobile/send-otp`;
      } else {
        url = `${API_BASE_URL}/abha/update/email/send-otp`;
      }

      const encryptedLoginId = await encryptString(loginId);
      if (!encryptedLoginId) {
        toast.error("Failed to encrypt. Please try again.");
        setIsPageLoading(false);
        return;
      }
      const param = { loginId: encryptedLoginId };
      const response = await axios.post(url, param, header);
      const dtResponse = response.data;

      if (dtResponse.success) {
        toast.success(dtResponse?.data?.message || "OTP sent successfully");
        setCurrentTxnId(dtResponse.data.txnId);
        setResendTimer(60);
        setResendCount(resendCount + 1);
        setOtpText("");
      } else {
        toast.error(
          dtResponse?.message || "Failed to resend OTP. Please try again.",
        );
      }
      setIsPageLoading(false);
    } catch (error) {
      setIsPageLoading(false);
      if (error.response?.data?.message === "X-token expired") {
        toast.error(error.response.data.message);
        setTimeout(() => {
          handleLogout();
        }, 3000);
      } else {
        toast.error(
          error.response?.data?.message ||
            "Failed to resend OTP. Please try again.",
        );
      }
    }
  };

  /**
   * Function used to set otp text
   */
  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only digits and up to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setOtpText(value);

      // Validate OTP
      if (value.length === 0) {
        setOtpError("OTP is required");
      } else if (value.length < 6) {
        setOtpError("OTP must be 6 digits");
      } else {
        setOtpError("");
      }
    }
  };

  /**
   * Functin used to verify abha number
   */
  const verifyOtp = async (event) => {
    event.preventDefault();
    setIsPageLoading(true);
    try {
      const encryptedOtp = await encryptString(OtpText);
      if (encryptedOtp) {
        // const sessionResponse = await createSession();
        //  const accessToken = sessionResponse?.accessToken;

        // if (!accessToken) {
        //   toast.error("Access token or X-token is missing.");
        //   return;
        // }
        let param = {};
        let url = "";
        const header = {
          headers: {
            "Content-Type": "application/json",
            // xtoken: `${xToken}`,
            // accesstoken: `${accessToken}`,
          },
        };
        if (verifyWith == "mobile") {
          url = `${API_BASE_URL}/abha/update/mobile/verify-otp`;
          param = {
            txnId: currentTxnId,
            otp: `${encryptedOtp}`,
          };
        } else {
          url = `${API_BASE_URL}/abha/update/email/verify-otp`;
          param = {
            txnId: currentTxnId,
            otp: `${encryptedOtp}`,
          };
        }
        const response = await axios.post(url, param, header);
        const dtResponse = response.data;
        if (dtResponse.success) {
          if (dtResponse?.data?.authResult === "success") {
            toast.success(dtResponse.data.message);
            setCurrentTxnId(dtResponse.data.txnId);
            setIsPageLoading(false);
            // Call the callback to refresh profile
            if (onVerificationSuccess) {
              onVerificationSuccess();
            }
            setTimeout(() => {
              setShowModal(false);
            }, 3000);
          } else {
            toast.error(dtResponse.data.message);
            setCurrentTxnId(dtResponse.data.txnId);
            setIsPageLoading(false);
          }
        } else {
          toast.error(
            dtResponse?.data.message ||
              "Failed to verify OTP. Please try again.",
          );
          setIsPageLoading(false);
        }
      } else {
        toast.error("Failed to encrypt OTP. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "X-token expired"
      ) {
        toast.error(error.response.data.message);
        setTimeout(() => {
          handleLogout();
        }, 3000);
      } else if (
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else {
        toast.error(
          error.response.data.message ||
            "Server error occurred. Please try again later.",
        );
      }
    }
  };

  return (
    <>
      <ToastContainer />
      {isPageLoading && <Loader />}
      <div
        className="modal fade show d-block verificationModel"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ background: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-bottom-0 flex-column-reverse">
              <div className="text-center headerText">
                <h5 className="modal-title" id="exampleModalLabel">
                  OTP Authentication
                </h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              />
            </div>
            <div className="modal-body">
              <div className="veryFicationType">
                <div className="feilds mb-2 w-75">
                  <label>Confirm OTP</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter OTP"
                    maxLength={6}
                    value={OtpText}
                    onChange={handleOtpChange}
                  />
                  {otpError && (
                    <span
                      style={{
                        color: "#dc3545",
                        fontSize: "12px",
                        marginTop: "5px",
                        display: "block",
                      }}
                    >
                      {otpError}
                    </span>
                  )}
                  <span
                    className="notes text-end"
                    onClick={() => {
                      if (resendTimer === 0 && resendCount < 3) {
                        handleResendOtp();
                      }
                    }}
                    style={{
                      pointerEvents:
                        resendTimer > 0 || resendCount >= 3 ? "none" : "auto",
                      color:
                        resendTimer > 0 || resendCount >= 3
                          ? "#999"
                          : "#007bff",
                      cursor:
                        resendTimer > 0 || resendCount >= 3
                          ? "not-allowed"
                          : "pointer",
                      display: "block",
                      marginTop: "5px",
                    }}
                  >
                    {resendTimer > 0
                      ? `00:${resendTimer < 10 ? "0" + resendTimer : resendTimer} Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`
                      : resendCount >= 3
                        ? "Maximum resend attempts reached"
                        : `Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`}
                  </span>
                </div>
              </div>
            </div>
            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="custBtn btnCancel"
                data-bs-dismiss="modal"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`custBtn ${OtpText.length === 6 ? "btnSuccess" : "disabled"}`}
                disabled={OtpText.length !== 6}
                onClick={verifyOtp}
              >
                Validate
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OTPAuthentication;
